import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const formatRepresentativeCase = ({
	rc_case_title: title,
	rc_citation: citation,
	rc_year: year,
	rc_court: court,
	rc_serial_number: serialNumber,
}) => {
	let representativeCase = title;

	if (citation) {
		representativeCase += `, ${citation}`;
	}

	if (year) {
		representativeCase += `, ${year}`;
	}

	if (court) {
		representativeCase += `, ${court}`;
	}

	if (serialNumber) {
		representativeCase += `, ${serialNumber}`;
	}

	return representativeCase;
};

const RepresentativeCases = (props) => {
	const representativeCases = props.data.representative_cases;

	if (!_.isArray(representativeCases) || _.isEmpty(representativeCases)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(representativeCases, representativeCase => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{formatRepresentativeCase(representativeCase)}
				</li>
			))}
		</ul>
	);
};

RepresentativeCases.propTypes = {
	data: PropTypes.object.isRequired,
};

export default RepresentativeCases;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/representative-cases.js